<header>
    <h3>{{ 'pages.residences.reviewDialog.title' | translate }}</h3>
    <button mat-icon-button aria-label="Close" (click)="closeDialog()">
        <span class="icon-close"></span>
    </button>
</header>

<div class="dialog-content">
    <!-- Applicant Section -->
    <div class="section" *ngIf="data.citizen">
        <div class="section-header">
            <mat-icon>person_outline</mat-icon>
            <span>{{ 'pages.residences.reviewDialog.applicant' | translate }}</span>
        </div>
        <div class="section-body applicant-info">
            <div class="applicant-row">
                <div class="applicant-avatar" *ngIf="data.citizen.picture">
                    <img [src]="data.citizen.picture" [alt]="citizenName" />
                </div>
                <div class="applicant-avatar applicant-avatar--placeholder" *ngIf="!data.citizen.picture">
                    <mat-icon>person</mat-icon>
                </div>
                <span class="applicant-name">{{ citizenName }}</span>
                <a *ngIf="citizenProfileLink"
                   [routerLink]="citizenProfileLink"
                   target="_blank"
                   class="profile-link">
                    <mat-icon>open_in_new</mat-icon>
                </a>
            </div>
            <div class="contact-row" *ngIf="data.citizen.email">
                <mat-icon>mail_outline</mat-icon>
                <span>{{ data.citizen.email }}</span>
            </div>
            <div class="contact-row" *ngIf="data.citizen.phone">
                <mat-icon>phone</mat-icon>
                <span>{{ data.citizen.phone }}</span>
            </div>
        </div>
    </div>

    <!-- Property Section -->
    <div class="section">
        <div class="section-header">
            <mat-icon>home</mat-icon>
            <span>{{ 'pages.residences.reviewDialog.residence' | translate }}</span>
            <span class="review-type-badge" *ngIf="isRenewal">{{ 'pages.residences.reviewDialog.renewal' | translate }}</span>
            <span class="review-type-badge review-type-badge--new" *ngIf="!isRenewal">{{ 'pages.residences.reviewDialog.newClaim' | translate }}</span>
        </div>
        <div class="section-body">
            <div class="address-row">
                <mat-icon>location_on</mat-icon>
                <div class="address-text">
                    <span class="address-line1">{{ addressLine1 }}</span>
                    <span class="address-line2">{{ addressLine2 }}</span>
                </div>
            </div>
            <div class="expiration-row" *ngIf="isRenewal && expirationDate">
                <mat-icon>event</mat-icon>
                <span>{{ 'pages.residences.reviewDialog.currentExpiration' | translate }}: {{ expirationDate | date:'mediumDate' }}</span>
            </div>
            <div class="rejection-note-row" *ngIf="previousRejectionNote">
                <mat-icon>info_outline</mat-icon>
                <div class="rejection-note-text">
                    <span class="rejection-note-label">{{ 'pages.residences.reviewDialog.previousRejection' | translate }}</span>
                    <span class="rejection-note-value">{{ previousRejectionNote }}</span>
                </div>
            </div>
            <!-- SubType Selector inside the property card -->
            <div class="subtype-selector" *ngIf="showSubTypeSelector && !showRejectForm">
                <app-form-select
                    [(ngModel)]="selectedSubType"
                    name="subType"
                    [options]="subTypeOptions"
                    placeholder="{{ 'pages.user-cards.create.steps.information.subTypes.label' | translate }}"
                    label="{{ 'pages.user-cards.create.steps.information.subTypes.label' | translate }} *">
                </app-form-select>
            </div>
        </div>
    </div>

    <!-- Proof Documents Section -->
    <div class="attachments-section" *ngIf="proofDocuments.length > 0">
        <div class="attachments-header-row">
            <span class="attachments-label">{{ 'pages.residences.reviewDialog.attachments' | translate }}</span>
            <button *ngIf="approvalGuidelines" mat-icon-button class="approval-guide-btn" (click)="showApprovalGuide = !showApprovalGuide">
                <span class="icon-info"></span>
            </button>
        </div>
        <div *ngIf="showApprovalGuide && approvalGuidelines" class="approval-guide-popover">
            <div class="approval-guide-header">
                <span>{{ 'pages.residences.reviewDialog.approvalGuide' | translate }}</span>
                <button class="approval-guide-close" (click)="showApprovalGuide = false"><span class="icon-close"></span></button>
            </div>
            <div class="approval-guide-content ql-content-wrapper" [innerHTML]="approvalGuidelines"></div>
        </div>
        <div *ngIf="supportingDocuments" class="supporting-documents">
            <div class="supporting-documents-content ql-content-wrapper" [innerHTML]="supportingDocuments"></div>
        </div>
        <div class="attachments-grid">
            <div *ngFor="let doc of proofDocuments"
                 class="attachment-thumb"
                 [ngSwitch]="docState(doc)"
                 (click)="openDocument(doc)">
                <img *ngSwitchCase="'image'" [src]="doc" [alt]="'pages.residences.reviewDialog.document' | translate" />
                <img *ngSwitchCase="'pdf-thumb'" [src]="pdfThumbnailState[doc]" [alt]="'pages.residences.reviewDialog.document' | translate" />
                <div *ngSwitchCase="'pdf-loading'" class="attachment-thumb-loading">
                    <mat-spinner diameter="24"></mat-spinner>
                </div>
                <div *ngSwitchCase="'pdf-error'" class="attachment-thumb-fallback">
                    <span class="icon-files"></span>
                </div>
            </div>
        </div>
    </div>

    <!-- Approval guide shown even when no attachments -->
    <div class="attachments-section" *ngIf="proofDocuments.length === 0 && approvalGuidelines">
        <div class="attachments-header-row">
            <span class="attachments-label"></span>
            <button mat-icon-button class="approval-guide-btn" (click)="showApprovalGuide = !showApprovalGuide">
                <span class="icon-info"></span>
            </button>
        </div>
        <div *ngIf="showApprovalGuide" class="approval-guide-popover">
            <div class="approval-guide-header">
                <span>{{ 'pages.residences.reviewDialog.approvalGuide' | translate }}</span>
                <button class="approval-guide-close" (click)="showApprovalGuide = false"><span class="icon-close"></span></button>
            </div>
            <div class="approval-guide-content ql-content-wrapper" [innerHTML]="approvalGuidelines"></div>
        </div>
    </div>
</div>

<footer>
    <button
        class="bciti-button bciti-button--red"
        (click)="handleReject()"
        [disabled]="loading">
        {{ 'pages.residences.reviewDialog.rejectButton' | translate }}
    </button>
    <button
        class="bciti-button bciti-button--blue"
        (click)="approve()"
        [disabled]="loading || (showSubTypeSelector && !selectedSubType)">
        <mat-spinner *ngIf="loading" diameter="18"></mat-spinner>
        <span *ngIf="!loading">{{ 'pages.residences.reviewDialog.approveButton' | translate }}</span>
    </button>
</footer>
